var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSurgeUpIcon = function SvgSurgeUpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F55F00",
    d: "M20.031 18.97a.75.75 0 1 1-1.061 1.06L12 13.06l-6.969 6.97a.75.75 0 1 1-1.061-1.06l7.5-7.5a.75.75 0 0 1 1.061 0zm-15-6.44 6.97-6.97 6.969 6.97a.75.75 0 1 0 1.061-1.06l-7.5-7.5a.75.75 0 0 0-1.061 0l-7.5 7.5a.75.75 0 1 0 1.061 1.06"
  })));
};
export default SvgSurgeUpIcon;